import { MagnifyingGlass } from 'phosphor-react'

type InputSearchProps = {
  placeholder?: string
  value: string
  onValueChange: (newValue: string) => void
  onSearch: () => void
  noButton?: boolean
}

export const SelectOptionsSearchInput = ({
  placeholder = '',
  value,
  onValueChange,
  onSearch,
  noButton,
}: InputSearchProps) => {
  const handleSearchValue = () => {
    if (noButton) {
      onSearch()
    }
  }

  return (
    <div className="p-2">
      <div className="relative w-full">
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          className="w-full p-3 pr-6 text-xs rounded-lg outline-none placeholder:text-xs md:text-sm md:placeholder:text-sm h-11 lg:pr-12 border-grey-500 border-1 text-grey-800 placeholder:text-grey-500 disabled:bg-grey-300 disabled:text-grey-500 lg:py-4 lg:text-sm"
          onKeyDown={(e) => e.stopPropagation()}
          onChange={(e) => {
            onValueChange(e.target.value)
            handleSearchValue()
          }}
        />

        {!noButton && (
          <button
            type="button"
            className="absolute p-[6px] -translate-y-1/2 rounded-full w- bg-secondary-dark right-2 top-1/2"
            onClick={() => onSearch()}
          >
            <MagnifyingGlass color="#fff" size={16} />
          </button>
        )}
      </div>
    </div>
  )
}
